import React from 'react';
export function CharacteristicsSection() {
  return <section data-id="element-4185">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-4186">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-4187">
          Characteristics of Mikron's MILL S - High Speed Machining Centers
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0 text-center space-y-8" data-id="element-4188">
        <div data-id="element-4189">
          <h3 className="text-3xl font-bold text-[#026ab7] mb-2" data-id="element-4190">
            Mikron MILL S
          </h3>
          <p className="text-xl font-bold text-orange" data-id="element-4191">
            Your Hard Milling Solution - 61 m/min LINEAR DRIVES
          </p>
        </div>

        <div className="max-w-3xl mx-auto text-left grid md:grid-cols-2 gap-8" data-id="element-4192">
          <div className="space-y-6" data-id="element-4193">
            <div data-id="element-4194">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-4195">
                Swiss Built Step-Tec Spindle
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-4196">
                <li data-id="element-4197">30k to 60k RPM - High RPM</li>
                <li data-id="element-4198">Oil/Air Lubricated - 24/7 Operation</li>
              </ul>
            </div>
            <div data-id="element-4199">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-4200">
                Linear Drives - Key to faster cycle times!
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-4201">
                <li data-id="element-4202">1.7G Acceleration - 2401 ipm</li>
                <li data-id="element-4203">Highest Accuracy and Cutting Speed</li>
              </ul>
            </div>
            <div data-id="element-4204">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-4205">
                Polymer Granite Base
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-4206">
                <li data-id="element-4207">
                  Highest level of thermostability and vibration dampening
                </li>
              </ul>
            </div>
          </div>

          <div className="space-y-6" data-id="element-4208">
            <div data-id="element-4209">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-4210">
                Designed for Productivity & Automation
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-4211">
                <li data-id="element-4212">
                  Ergonomic, No Operator Interference - 24/7 Lights Out
                  Machining
                </li>
              </ul>
            </div>
            <div data-id="element-4213">
              <h4 className="font-bold text-lg text-navy mb-1" data-id="element-4214">
                Heidenhain CNC
              </h4>
              <ul className="list-disc list-inside text-gray-700 ml-2" data-id="element-4215">
                <li data-id="element-4216">Best in Class for 5-Axis, Contouring, Fully Loaded</li>
              </ul>
            </div>
            <div data-id="element-4217">
              <h4 className="font-bold text-lg text-orange" data-id="element-4218">
                Easily Equipped for Graphite & Hard Milling
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>;
}